
import { handleResponse, guestHeader, authHeader } from "helpers";

export const AuthService = {
    login,
    passwordRequest,
    passwordReset,
    logout,
    autoLogin
};

function login(email, password, logged) {

    const requestOptions = {
        method: 'POST',
        headers: guestHeader(),
        body: JSON.stringify({ email, password, logged, request_from: "pnp" })
    };

    return fetch(`${process.env.REACT_APP_URL}/auth/login`, requestOptions)
        .then(handleResponse)
        .then(user => {
            // login successful if there's a jwt token in the response
            if (user.success && !user.logged && !user.requires_2fa) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('eventBuizz', JSON.stringify(user));
                localStorage.setItem('interface_language_id', user.data.inferface_language_id);
            }
            else if(user.redirect == "update_password"){
                localStorage.setItem('update_password_organizer_id', user.organizer_id);
                window.location.href = "/update-password";
            }
            else if(user.success && user.requires_2fa){
                localStorage.setItem('eventBuizz_pnp', JSON.stringify(user));
                window.location.href = "/last-2fa-request";
            }
            return user;
        });
}

function autoLogin(token) {

    const requestOptions = {
        method: 'GET',
        headers: guestHeader()
    };

    return fetch(`${process.env.REACT_APP_URL}/auth/auto-login/${token}`, requestOptions)
        .then(handleResponse)
        .then(user => {
            // login successful if there's a jwt token in the response
            if (user.success && !user.logged) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('eventBuizz', JSON.stringify(user));
                localStorage.setItem('interface_language_id', user.data.inferface_language_id);
            }
            return user;
        });
}

function passwordRequest(email) {

    const requestOptions = {
        method: 'POST',
        headers: guestHeader(),
        body: JSON.stringify({ email })
    };

    return fetch(`${process.env.REACT_APP_URL}/auth/password/email`, requestOptions)
        .then(handleResponse);
        // .then(response => {
        //     response.email = email;
        //     console.log(response.email);
        //     localStorage.setItem('eventBuizz_pnp', JSON.stringify(response.email));
        //     return response;
        // });
}

function passwordReset(email, password, password_confirmation, token) {

    const requestOptions = {
        method: 'POST',
        headers: guestHeader(),
        body: JSON.stringify({ email, password, password_confirmation, token, request_from: "pnp" })
    };

    return fetch(`${process.env.REACT_APP_URL}/auth/password/reset`, requestOptions)
        .then(handleResponse);
}

function logout() {

    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };

    return fetch(`${process.env.REACT_APP_URL}/auth/logout`, requestOptions)
        .then(handleResponse)
        .then(response => {
            localStorage.removeItem('eventBuizz');
            return response;
        });
}

